import { IReward } from "api/types";

// Sort rewards by points required in ascending order
export const sortRewards = (rewards: IReward[]): IReward[] =>
  rewards.sort((rewardA: IReward, rewardB: IReward) => {
    if (rewardA.pointsRequired === rewardB.pointsRequired) {
      return (rewardA.name || "").localeCompare(rewardB.name || "");
    } else if ((rewardA.pointsRequired || 0) < (rewardB.pointsRequired || 0)) {
      return -1;
    } else if ((rewardA.pointsRequired || 0) > (rewardB.pointsRequired || 0)) {
      return 1;
    } else {
      return 0;
    }
  });



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/utils.ts